import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPlaybookById, getSectionById } from '../../../data/playbookTaxonomy';
import useScrollReset from '../../../hooks/useScrollReset';
import PlaybookLayout from '../../../components/layout/PlaybookLayout';

// Import all section components for team-health-checks
import TeamHealthChecksKeyInfo from '../team-health-checks/key-info';
import TeamHealthChecksHowToExecute from '../team-health-checks/how-to-execute';
import TeamHealthChecksStage1 from '../team-health-checks/stage-1';
import TeamHealthChecksStage2 from '../team-health-checks/stage-2';
import TeamHealthChecksStage3 from '../team-health-checks/stage-3';
import TeamHealthChecksStage4 from '../team-health-checks/stage-4';
import TeamHealthChecksUsefulResources from '../team-health-checks/useful-resources';
import TeamHealthChecksFinalThoughts from '../team-health-checks/final-thoughts';

// Import section components for working through conflict
import WorkingThroughConflictKeyInfo from '../working-through-conflict/key-info';
import WorkingThroughConflictHowToExecute from '../working-through-conflict/how-to-execute';
import WorkingThroughConflictStage1 from '../working-through-conflict/stage-1';
import WorkingThroughConflictStage2 from '../working-through-conflict/stage-2';
import WorkingThroughConflictStage3 from '../working-through-conflict/stage-3';
import WorkingThroughConflictUsefulResources from '../working-through-conflict/useful-resources';
import WorkingThroughConflictFinalThoughts from '../working-through-conflict/final-thoughts';

// Import section components for setting boundaries
import SettingBoundariesKeyInfo from '../setting-boundaries/key-info';
import SettingBoundariesUsefulResources from '../setting-boundaries/useful-resources';
import SettingBoundariesFinalThoughts from '../setting-boundaries/final-thoughts';
import SettingBoundariesHowToExecute from '../setting-boundaries/how-to-execute';
import SettingBoundariesStage1 from '../setting-boundaries/stage-1';
import SettingBoundariesStage2 from '../setting-boundaries/stage-2';
import SettingBoundariesStage3 from '../setting-boundaries/stage-3';

// Import section components for manager community
import ManagerCommunityKeyInfo from '../manager-community/key-info';
import ManagerCommunityHowToExecute from '../manager-community/how-to-execute';
import ManagerCommunityStage1 from '../manager-community/stage-1';
import ManagerCommunityStage2 from '../manager-community/stage-2';
import ManagerCommunityStage3 from '../manager-community/stage-3';
import ManagerCommunityStage4 from '../manager-community/stage-4';
import ManagerCommunityUsefulResources from '../manager-community/useful-resources';
import ManagerCommunityFinalThoughts from '../manager-community/final-thoughts';

// Import section components for we-fucked-up
import WeFuckedUpKeyInfo from '../we-fucked-up/key-info';
import WeFuckedUpHowToExecute from '../we-fucked-up/how-to-execute';
import WeFuckedUpStage1 from '../we-fucked-up/stage-1';
import WeFuckedUpStage2 from '../we-fucked-up/stage-2';
import WeFuckedUpStage3 from '../we-fucked-up/stage-3';
import WeFuckedUpUsefulResources from '../we-fucked-up/useful-resources';
import WeFuckedUpFinalThoughts from '../we-fucked-up/final-thoughts';

// Import section components for feedback culture
import FeedbackCultureKeyInfo from '../feedback-culture/key-info';
import FeedbackCultureHowToExecute from '../feedback-culture/how-to-execute';
import FeedbackCultureStage1 from '../feedback-culture/stage-1';
import FeedbackCultureStage2 from '../feedback-culture/stage-2';
import FeedbackCultureStage3 from '../feedback-culture/stage-3';
import FeedbackCultureUsefulResources from '../feedback-culture/useful-resources';
import FeedbackCultureFinalThoughts from '../feedback-culture/final-thoughts';

// Import section components for transparency charter
import TransparencyCharterKeyInfo from '../transparency-charter/key-info';
import TransparencyCharterHowToExecute from '../transparency-charter/how-to-execute';
import TransparencyCharterStage1 from '../transparency-charter/stage-1';
import TransparencyCharterStage2 from '../transparency-charter/stage-2';
import TransparencyCharterStage3 from '../transparency-charter/stage-3';
import TransparencyCharterUsefulResources from '../transparency-charter/useful-resources';
import TransparencyCharterFinalThoughts from '../transparency-charter/final-thoughts';

// Import section components for culture offsite
import CultureOffsiteKeyInfo from '../culture-offsite/key-info';
import CultureOffsiteHowToExecute from '../culture-offsite/how-to-execute';
import CultureOffsiteStage1 from '../culture-offsite/stage-1';
import CultureOffsiteStage2 from '../culture-offsite/stage-2';
import CultureOffsiteStage3 from '../culture-offsite/stage-3';
import CultureOffsiteUsefulResources from '../culture-offsite/useful-resources';
import CultureOffsiteFinalThoughts from '../culture-offsite/final-thoughts';

// Import section components for resetting-behaviours
import ResettingBehavioursKeyInfo from '../resetting-behaviours/key-info';
import ResettingBehavioursHowToExecute from '../resetting-behaviours/how-to-execute';
import ResettingBehavioursStage1 from '../resetting-behaviours/stage-1';
import ResettingBehavioursStage2 from '../resetting-behaviours/stage-2';
import ResettingBehavioursStage3 from '../resetting-behaviours/stage-3';
import ResettingBehavioursUsefulResources from '../resetting-behaviours/useful-resources';
import ResettingBehavioursFinalThoughts from '../resetting-behaviours/final-thoughts';

// Import section components for storytelling-with-data
import StorytellingWithDataKeyInfo from '../storytelling-with-data/key-info';
import StorytellingWithDataHowToExecute from '../storytelling-with-data/how-to-execute';
import StorytellingWithDataStage1 from '../storytelling-with-data/stage-1';
import StorytellingWithDataStage2 from '../storytelling-with-data/stage-2';
import StorytellingWithDataUsefulResources from '../storytelling-with-data/useful-resources';
import StorytellingWithDataFinalThoughts from '../storytelling-with-data/final-thoughts';

// Import section components for employer brand
import EmployerBrandKeyInfo from '../employer-brand-unfiltered/key-info';
import EmployerBrandHowToExecute from '../employer-brand-unfiltered/how-to-execute';
import EmployerBrandStage1 from '../employer-brand-unfiltered/stage-1';
import EmployerBrandStage2 from '../employer-brand-unfiltered/stage-2';
import EmployerBrandStage3 from '../employer-brand-unfiltered/stage-3';
import EmployerBrandUsefulResources from '../employer-brand-unfiltered/useful-resources';
import EmployerBrandFinalThoughts from '../employer-brand-unfiltered/final-thoughts';

// Import section components for leverage AI
import LeverageAIKeyInfo from '../leverage-ai-for-you-and-your-org/key-info';
import LeverageAIHowToExecute from '../leverage-ai-for-you-and-your-org/how-to-execute';
import LeverageAIStage1 from '../leverage-ai-for-you-and-your-org/stage-1';
import LeverageAIStage2 from '../leverage-ai-for-you-and-your-org/stage-2';
import LeverageAIStage3 from '../leverage-ai-for-you-and-your-org/stage-3';
import LeverageAIUsefulResources from '../leverage-ai-for-you-and-your-org/useful-resources';
import LeverageAIFinalThoughts from '../leverage-ai-for-you-and-your-org/final-thoughts';

// Import section components for how-to-build-launch-embed-performance
import PerformanceFrameworkKeyInfo from '../how-to-build-launch-embed-performance/key-info';
import PerformanceFrameworkHowToExecute from '../how-to-build-launch-embed-performance/how-to-execute';
import PerformanceFrameworkStage1 from '../how-to-build-launch-embed-performance/stage-1';
import PerformanceFrameworkStage2 from '../how-to-build-launch-embed-performance/stage-2';
import PerformanceFrameworkStage3 from '../how-to-build-launch-embed-performance/stage-3';
import PerformanceFrameworkStage4 from '../how-to-build-launch-embed-performance/stage-4';
import PerformanceFrameworkStage5 from '../how-to-build-launch-embed-performance/stage-5';
import PerformanceFrameworkStage6 from '../how-to-build-launch-embed-performance/stage-6';
import PerformanceFrameworkUsefulResources from '../how-to-build-launch-embed-performance/useful-resources';
import PerformanceFrameworkFinalThoughts from '../how-to-build-launch-embed-performance/final-thoughts';

const SECTION_COMPONENTS = {
  'team-health-checks': {
    'key-info': TeamHealthChecksKeyInfo,
    'how-to-execute': TeamHealthChecksHowToExecute,
    'stage-1': TeamHealthChecksStage1,
    'stage-2': TeamHealthChecksStage2,
    'stage-3': TeamHealthChecksStage3,
    'stage-4': TeamHealthChecksStage4,
    'useful-resources': TeamHealthChecksUsefulResources,
    'final-thoughts': TeamHealthChecksFinalThoughts,
  },
  'working-through-conflict': {
    'key-info': WorkingThroughConflictKeyInfo,
    'how-to-execute': WorkingThroughConflictHowToExecute,
    'stage-1': WorkingThroughConflictStage1,
    'stage-2': WorkingThroughConflictStage2,
    'stage-3': WorkingThroughConflictStage3,
    'useful-resources': WorkingThroughConflictUsefulResources,
    'final-thoughts': WorkingThroughConflictFinalThoughts,
  },
  'setting-boundaries': {
    'key-info': SettingBoundariesKeyInfo,
    'how-to-execute': SettingBoundariesHowToExecute,
    'stage-1': SettingBoundariesStage1,
    'stage-2': SettingBoundariesStage2,
    'stage-3': SettingBoundariesStage3,
    'useful-resources': SettingBoundariesUsefulResources,
    'final-thoughts': SettingBoundariesFinalThoughts,
  },
  'manager-community': {
    'key-info': ManagerCommunityKeyInfo,
    'how-to-execute': ManagerCommunityHowToExecute,
    'stage-1': ManagerCommunityStage1,
    'stage-2': ManagerCommunityStage2,
    'stage-3': ManagerCommunityStage3,
    'stage-4': ManagerCommunityStage4,
    'useful-resources': ManagerCommunityUsefulResources,
    'final-thoughts': ManagerCommunityFinalThoughts,
  },
  'we-fucked-up': {
    'key-info': WeFuckedUpKeyInfo,
    'how-to-execute': WeFuckedUpHowToExecute,
    'stage-1': WeFuckedUpStage1,
    'stage-2': WeFuckedUpStage2,
    'stage-3': WeFuckedUpStage3,
    'useful-resources': WeFuckedUpUsefulResources,
    'final-thoughts': WeFuckedUpFinalThoughts,
  },
  'feedback-culture': {
    'key-info': FeedbackCultureKeyInfo,
    'how-to-execute': FeedbackCultureHowToExecute,
    'stage-1': FeedbackCultureStage1,
    'stage-2': FeedbackCultureStage2,
    'stage-3': FeedbackCultureStage3,
    'useful-resources': FeedbackCultureUsefulResources,
    'final-thoughts': FeedbackCultureFinalThoughts,
  },
  'transparency-charter': {
    'key-info': TransparencyCharterKeyInfo,
    'how-to-execute': TransparencyCharterHowToExecute,
    'stage-1': TransparencyCharterStage1,
    'stage-2': TransparencyCharterStage2,
    'stage-3': TransparencyCharterStage3,
    'useful-resources': TransparencyCharterUsefulResources,
    'final-thoughts': TransparencyCharterFinalThoughts,
  },
  'culture-offsite': {
    'key-info': CultureOffsiteKeyInfo,
    'how-to-execute': CultureOffsiteHowToExecute,
    'stage-1': CultureOffsiteStage1,
    'stage-2': CultureOffsiteStage2,
    'stage-3': CultureOffsiteStage3,
    'useful-resources': CultureOffsiteUsefulResources,
    'final-thoughts': CultureOffsiteFinalThoughts,
  },
  'resetting-behaviours': {
    'key-info': ResettingBehavioursKeyInfo,
    'how-to-execute': ResettingBehavioursHowToExecute,
    'stage-1': ResettingBehavioursStage1,
    'stage-2': ResettingBehavioursStage2,
    'stage-3': ResettingBehavioursStage3,
    'useful-resources': ResettingBehavioursUsefulResources,
    'final-thoughts': ResettingBehavioursFinalThoughts,
  },
  'storytelling-with-data': {
    'key-info': StorytellingWithDataKeyInfo,
    'how-to-execute': StorytellingWithDataHowToExecute,
    'stage-1': StorytellingWithDataStage1,
    'stage-2': StorytellingWithDataStage2,
    'useful-resources': StorytellingWithDataUsefulResources,
    'final-thoughts': StorytellingWithDataFinalThoughts,
  },
  'employer-brand-unfiltered': {
    'key-info': EmployerBrandKeyInfo,
    'how-to-execute': EmployerBrandHowToExecute,
    'stage-1': EmployerBrandStage1,
    'stage-2': EmployerBrandStage2,
    'stage-3': EmployerBrandStage3,
    'useful-resources': EmployerBrandUsefulResources,
    'final-thoughts': EmployerBrandFinalThoughts,
  },
  'leverage-ai-for-you-and-your-org': {
    'key-info': LeverageAIKeyInfo,
    'how-to-execute': LeverageAIHowToExecute,
    'stage-1': LeverageAIStage1,
    'stage-2': LeverageAIStage2,
    'stage-3': LeverageAIStage3,
    'useful-resources': LeverageAIUsefulResources,
    'final-thoughts': LeverageAIFinalThoughts,
  },
  'how-to-build-launch-embed-performance': {
    'key-info': PerformanceFrameworkKeyInfo,
    'how-to-execute': PerformanceFrameworkHowToExecute,
    'stage-1': PerformanceFrameworkStage1,
    'stage-2': PerformanceFrameworkStage2,
    'stage-3': PerformanceFrameworkStage3,
    'stage-4': PerformanceFrameworkStage4,
    'stage-5': PerformanceFrameworkStage5,
    'stage-6': PerformanceFrameworkStage6,
    'useful-resources': PerformanceFrameworkUsefulResources,
    'final-thoughts': PerformanceFrameworkFinalThoughts,
  },
  // Add mappings for other playbooks here
};

const PlaybookSection = () => {
  const { playbookId, sectionId } = useParams();
  const navigate = useNavigate();
  const playbook = getPlaybookById(playbookId);
  const section = getSectionById(playbookId, sectionId);
  const [loading, setLoading] = useState(true);

  // AGGRESSIVE SCROLL RESET - Use dedicated hook for scroll management
  useScrollReset([playbookId, sectionId]);

  useEffect(() => {
    // Handle cases where the section doesn't exist
    if (playbookId && !section) {
      // Navigate to the first section if current section not found
      if (playbook && playbook.sections.length > 0) {
        navigate(`/playbooks/${playbookId}/${playbook.sections[0].id}`, { replace: true });
      }
    } else {
      setLoading(false);
    }
  }, [playbookId, sectionId, playbook, section, navigate]);
  
  if (loading || !playbook || !section) {
    return <div>Loading...</div>;
  }

  // Get the component for this section
  const SectionComponent = SECTION_COMPONENTS[playbookId]?.[sectionId];

  // Generate breadcrumbs for the PlaybookLayout
  const breadcrumbs = [
    { label: 'Home', to: '/dashboard' },
    { label: 'Playbook Library', to: '/content' },
    { label: playbook.title, to: `/playbooks/${playbookId}/key-info` },
    { label: section.title }
  ];

  return (
    <>
      {SectionComponent ? (
        <SectionComponent />
      ) : (
        <DefaultSection section={section} sectionId={sectionId} />
      )}
    </>
  );
};

// Default section component when a specific section component can't be found
const DefaultSection = ({ section, sectionId }) => {
  return (
    <div id={sectionId} className="max-w-none text-gray-100">
      <h1 id="overview" className="text-3xl font-semibold text-white mb-6">{section.title}</h1>
      <p className="text-lg leading-relaxed text-gray-300 mb-8">{section.description}</p>
      
      <div className="my-10 p-6 bg-gray-800/30 rounded-lg border border-gray-700/50">
        <h2 id="content-status" className="text-xl font-semibold text-white mb-4">Content Coming Soon</h2>
        <p className="text-base text-gray-300 leading-relaxed">
          This section is under development. Check back soon for the full content.
        </p>
      </div>
      
      <h2 id="what-to-expect" className="text-xl font-semibold text-white mb-4">What to Expect</h2>
      <p className="text-base text-gray-300 leading-relaxed mb-4">
        When completed, this section will provide valuable insights and practical guidance on {section.title.toLowerCase()}.
      </p>
    </div>
  );
};

export default PlaybookSection; 